// Other
import { inject, observer } from 'mobx-react'
import React, { useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { WorkPageWrapper } from './TextShoppingCouponStylePage'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { runInAction } from 'mobx'
// Ant design
import {
  Button,
  Menu,
  message,
  Modal,
  Col,
  Form,
  Input,
  Row,
  Select,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
// Component
import PageTitle from '../../components/PageTitle'

// Other
import AccessControlAction from '../../components/AccessControlAction'
import { ACL_ACTION_TYPE } from '../../constants'
import ShoppingCouponTable from './ShoppingCouponTable'
import ShoppingCouponCreate from './ShoppingCouponCreate'
import ShoppingCouponStore from '../../stores/ShoppingCouponStore'
import selectPeopleStore from '../../stores/selectPeopleStore'
import AppPageHeader from '../../components/AppPageHeader'
import {
  AddCircleOutlineIcon,
  MagnifierOutlineIcon,
} from '../../components/AppIcon'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import ShoppingCouponPageAdvanceFilterV2 from './ShoppingCouponPageAdvanceFilterV2'

const ManagementAssetWarehousePage = props => {
  const [isVisibleCreateModal, setIsVisibleCreateModal] = useState(false)
  //trigger refresh data
  const [refreshData, setRefreshData] = useState(0)

  const location = useLocation()
  const history = useHistory()

  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const handleToggleCreateModal = bool => event => {
    setIsVisibleCreateModal(bool)
    ShoppingCouponStore.clearFormCreate()
    selectPeopleStore.clearSelected()
  }

  const handleCreateSuccess = () => {
    setRefreshData(prev => prev + 1)
    selectPeopleStore.clearSelected()
  }

  const onSearchProposal = values => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        title: values?.trim() || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/shopping-coupon?${queryStringStringify}`)
  }

  return (
    // isVisibleDrawerWork={isVisibleDrawerWork}
    <WorkPageWrapper>
      <DashboardLayout>
        <Helmet>
          <title>Quy trình mua sắm | Công việc</title>
        </Helmet>
        <AppPageHeader
          title="Quy trình mua sắm"
          addon={
            <>
              <Input.Search
                allowClear
                onSearch={onSearchProposal}
                defaultValue={queryStringParse?.title}
                maxLength={500}
                placeholder="Tìm kiếm theo tiêu đề"
                enterButton={
                  <MagnifierOutlineIcon
                    style={{ color: '#000', width: 16, height: 16 }}
                  />
                }
                className="custom-search-input fixed-width"
              />

              <ShoppingCouponPageAdvanceFilterV2 />

              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.create__QUY_TRINH_MUA_SAM}>
                <Button
                  className="icon-btn"
                  type={'primary'}
                  icon={
                    <AddCircleOutlineIcon
                      style={{ color: '#fff', width: 16, height: 16 }}
                    />
                  }
                  onClick={handleToggleCreateModal(true)}>
                  Tạo mới
                </Button>
              </AccessControlAction>
            </>
          }
        />

        <ContentBlockWrapper>
          {/* onSearch={isVisibleCreateModal} */}
          <ShoppingCouponTable
            isVisibleCreateModal={isVisibleCreateModal}
            refreshData={refreshData}
            {...props}
          />
        </ContentBlockWrapper>
      </DashboardLayout>
      <Modal
        style={{ top: 30 }}
        wrapClassName="custom-modal-wrapper"
        width="90dvw"
        title={'Tạo mới quy trình mua sắm'}
        visible={isVisibleCreateModal}
        maskClosable={false}
        onCancel={handleToggleCreateModal(false)}
        footer={null}
        destroyOnClose>
        {isVisibleCreateModal && (
          <ShoppingCouponCreate
            onCancel={handleToggleCreateModal(false)}
            onSuccess={handleCreateSuccess}
          />
        )}
      </Modal>
    </WorkPageWrapper>
  )
}

export default inject(
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'selectPeopleStore',
  'managementAssetWarehouseStore'
)(observer(ManagementAssetWarehousePage))
